import {
  Briefcase,
  Cake,
  Factory,
  Gift,
  HandHeart,
  HeartHandshake,
  MapPin,
  Split,
  Truck,
  UserRound,
  Wheat,
  type LucideIcon,
} from "lucide-react";
import type { CrmRecordType } from "@/lib/api/crm/masters";

export const recordTypeLabels: Record<CrmRecordType, string> = {
  producer: "Producer",
  non_client: "Non-client",
  client: "Client",
  end_user: "End user",
  location: "Location",
  carrier: "Carrier",
  payment_split: "Payment Split",
  birthday_fund_donor: "Birthday Donor",
  birthday_fund_volunteer: "Birthday Volunteer",
  birthday_fund_destination: "Birthday Destination",
  birthday_fund_nominating_partner: "Birthday Nominating Partner",
};

export const recordTypePluralLabels: Record<CrmRecordType, string> = {
  producer: "Producers",
  non_client: "Non-clients",
  client: "Clients",
  end_user: "End users",
  location: "Locations",
  carrier: "Carriers",
  payment_split: "Payment Splits",
  birthday_fund_donor: "Birthday Donors",
  birthday_fund_volunteer: "Birthday Volunteers",
  birthday_fund_destination: "Birthday Destinations",
  birthday_fund_nominating_partner: "Birthday Nominating Partners",
};

export const recordTypeBadgeClasses: Record<CrmRecordType, string> = {
  producer: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  non_client: "bg-slate-50 text-slate-700 ring-slate-600/20",
  client: "bg-blue-50 text-blue-700 ring-blue-600/20",
  end_user: "bg-violet-50 text-violet-700 ring-violet-600/20",
  location: "bg-amber-50 text-amber-800 ring-amber-600/20",
  carrier: "bg-cyan-50 text-cyan-700 ring-cyan-600/20",
  payment_split: "bg-rose-50 text-rose-700 ring-rose-600/20",
  birthday_fund_donor: "bg-pink-50 text-pink-700 ring-pink-600/20",
  birthday_fund_volunteer: "bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-600/20",
  birthday_fund_destination: "bg-orange-50 text-orange-700 ring-orange-600/20",
  birthday_fund_nominating_partner: "bg-teal-50 text-teal-700 ring-teal-600/20",
};

/** Solid accent per type, for icons and markers. */
export const recordTypeAccentClasses: Record<CrmRecordType, string> = {
  producer: "bg-emerald-500 text-white",
  non_client: "bg-slate-500 text-white",
  client: "bg-blue-500 text-white",
  end_user: "bg-violet-500 text-white",
  location: "bg-amber-500 text-white",
  carrier: "bg-cyan-500 text-white",
  payment_split: "bg-rose-500 text-white",
  birthday_fund_donor: "bg-pink-500 text-white",
  birthday_fund_volunteer: "bg-fuchsia-500 text-white",
  birthday_fund_destination: "bg-orange-500 text-white",
  birthday_fund_nominating_partner: "bg-teal-500 text-white",
};

export const recordTypeIcons: Record<CrmRecordType, LucideIcon> = {
  producer: Wheat,
  non_client: UserRound,
  client: Briefcase,
  end_user: Factory,
  location: MapPin,
  carrier: Truck,
  payment_split: Split,
  birthday_fund_donor: Gift,
  birthday_fund_volunteer: HandHeart,
  birthday_fund_destination: Cake,
  birthday_fund_nominating_partner: HeartHandshake,
};

/** Display order of record types on the detail page. */
export const recordTypeOrder: CrmRecordType[] = [
  "producer",
  "non_client",
  "client",
  "end_user",
  "carrier",
  "location",
  "payment_split",
  "birthday_fund_donor",
  "birthday_fund_volunteer",
  "birthday_fund_destination",
  "birthday_fund_nominating_partner",
];
